<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true,
              hideToolbar: true
            }),
            new fields.Input({
              label: 'Caption',
              modelPath: [this, 'form', 'caption'],
              multilingual: true
            }),
            new fields.Image({
              label: 'Image',
              modelPath: [this, 'form', 'image'],
              required: true,
              onlyShowCoverCrop: true
            }),
            new fields.Link({
              label: 'Image link (on click)',
              modelPath: [this, 'form', 'image_link'],
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
